import { Link, useLocation } from 'react-router-dom';
import React from 'react';
import house   from './house.svg';
import compass from './compass.svg';
import plus    from './plus.svg';
import user    from './user.svg';
import NotificationBell from './NotificationBell';
import logo    from './logo.png';
import './navbar.css';

export default function Navbar() {
  const { pathname } = useLocation();

  // ✅ Admin check
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL;

  const links = [
    { to: "/home",        icon: house,   label: "Home"        },
    { to: "/discover",    icon: compass, label: "Discover"    },
    { to: "/create-trip", icon: plus,    label: "Create Trip" },
    { to: "/profile/1",   icon: user,    label: "Profile"     },
  ];

  // ✅ Hide Create Trip for non-admin
  const visibleLinks = links.filter(link =>
    link.to !== "/create-trip" || currentUser?.email === ADMIN_EMAIL
  );

  return (
    <nav className="nb-nav">
      <Link to="/home" className="nb-brand">
        <div className="nb-brand-icon">
          <img src={logo} alt="TrailNest" className="nb-brand-logo" />
        </div>
        <span className="nb-brand-name">Trail<span>Nest</span></span>
      </Link>
      <ul className="nb-links">
        {/* ✅ visibleLinks instead of links */}
        {visibleLinks.map(({ to, icon, label }) => {
          const isActive = pathname === to || pathname.startsWith(to + "/");
          return (
            <li key={to}>
              <Link to={to} className={`nb-link ${isActive ? "nb-link-active" : ""}`}>
                <img src={icon} className="nb-icon" alt={label} />
                {label}
                {isActive && <span className="nb-active-dot" />}
              </Link>
            </li>
          );
        })}
      </ul>
      <NotificationBell />
    </nav>
  );
}